/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "/Users/pajk01/workspace/n34220_autoconfig_STATIC/vue-scrm_temp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ACTION_APPTREG_GETMYREGLIST } from '@/store/mutation_types';
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex';
import Cons from '@/common/Constant';
import CompRegDone from './CompRegDone';
import { GetMyRegList } from '@/api/apptReg';
export default {
  data: function data() {
    return {
      apptStatus: '',
      index: -1,
      apptInfo: {},
      apptObj: {},
      type: ''
    };
  },
  components: {
    CompRegDone: CompRegDone
  },
  computed: {
    payEndTime: function payEndTime() {
      if (this.type != 'current') {
        return '';
      }

      var obj = this.apptInfo;
      var leftTime = parseInt(15 * 60 - obj.paySurplus);

      if (leftTime < 0) {
        obj.payEndTime = 0;
      } else {
        var payEndTime = new Date().getTime() + leftTime * 1000;
        payEndTime = Utils.gettimeFormat("yyyy-MM-dd hh:mm:ss", payEndTime);
        return payEndTime;
      }

      return '';
    }
  },
  created: function created() {
    this.apptDetailAjax('create');
  },
  mounted: function mounted() {},
  methods: _objectSpread(_objectSpread({}, mapActions({
    ACTION_APPTREG_GETMYREGLIST: ACTION_APPTREG_GETMYREGLIST
  })), {}, {
    apptDetailAjax: function apptDetailAjax(flag) {
      var _this = this;

      var _this$$route$query = this.$route.query,
          recordId = _this$$route$query.recordId,
          apptOrderCode = _this$$route$query.apptOrderCode;
      GetMyRegList({
        recordId: recordId,
        apptOrderCode: apptOrderCode
      }).then(function (data) {
        _this.apptInfo = data.apptRecords[0];
        _this.apptObj = Cons.APPT_SCRM_STATUS_LIST.find(function (x) {
          return x.reservationStatus == _this.apptInfo.reservationStatus;
        });
        _this.type = _this.apptObj.type;
        _this.apptStatus = _this.apptObj.statusDesc;
      });

      if (!flag || flag != 'create') {
        this.ACTION_APPTREG_GETMYREGLIST();
      } // let obj = {};
      // obj.index = this.index;
      // this.setApptDetail();

    }
  })
};